export enum BoardIntegrationTypeEnum {
  POST_TO_BOARD = "Post to board",
}
